import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useBannedStatus } from 'components/BannedStatusWrapper';
import { withDefaultUIHandler } from '../utils/index';
import { useLocation } from 'react-router-dom';
import { VERIFY_PAGE } from 'constants/route.const';

/**
 * @template T
 * @param {() => Promise<T>} service
 * @param {any[]} deps
 * @returns {{data: T | null, error: Error, isLoading: Boolean, call: (...parameters) => Promise<T> }}
 */
function useService(service, deps, formator) {
  const [result, setResult] = useState({
    data: null,
    error: null,
    isLoading: false,
  });
  const oldResultRef = useRef(result);
  const { bannedModal, setBannedModal } = useBannedStatus();
  const location = useLocation();
  oldResultRef.current = result;

  const call = useCallback((...args) => {
    return withDefaultUIHandler(async () => {
      setResult(v => ({ ...v, isLoading: true }));
      try {
        const data = await service(...args);

        const newData = formator
          ? formator(data, oldResultRef.current.data)
          : data;
        setResult(v => ({
          ...v,
          data: newData,
          error: null,
          isLoading: false,
        }));
        return data;
      } catch (error) {
        if (
          location.pathname !== VERIFY_PAGE &&
          (error?.data?.err_code === 1003 || error?.data?.err_code === 1004)
        ) {
          setBannedModal(true);
        }
        setResult(v => ({ ...v, error, isLoading: false }));
        return Promise.reject(error);
      }
    });
  }, deps);

  const opt = useMemo(() => {
    return { ...result, call };
  }, [result, call]);

  return opt;
}

export default useService;
